import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { seleccionarPagina } from "../../../features/ui/uiSlice";
import { ValidacionComponent } from "../../../components/ValidacionComponent";
import { EndosoComponent } from "../../../components/EndosoComponent";

export const EndosoScreen = () => {
  const [validacion, setValidacion] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(seleccionarPagina("p-endoso"));
  }, [0]);
  if (!validacion) {
    return (
      <ValidacionComponent
        inactivo={true}
        validacion={validacion}
        setValidacion={setValidacion}
      />
    );
  }
  return (
    <>
      <div className="w-full p-5">
        <div className="mt-2 grid grid-cols-1 gap-10 px-2 sm:grid-cols-1 lg:grid-cols-1">
          <EndosoComponent />
        </div>
      </div>
    </>
  );
};
